import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  ViewChildren,
  QueryList,
} from '@angular/core';
import { AuthService } from '../../../_services/auth.service';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { ToastrService } from 'src/app/_services/toastr.service';
import { AppComponent } from 'src/app/app.component';
import { HomeComponent } from '../../home.component';
declare var $;
import { NgbDateStruct, NgbCalendar } from '@ng-bootstrap/ng-bootstrap';
import { NavService } from 'src/app/_services/nav.service';

import { DecimalPipe } from '@angular/common';
import { Observable } from 'rxjs';
import { SortService } from 'src/app/_services/sort.service';
import {
  SortColumn,
  SortDirection,
  SortEvent,
  NgbdSortableHeader,
} from '../irm/sortable.directive';
import { DownloadsService } from 'src/app/_services/downloads.service';
import {
  ModalDismissReasons,
  NgbModal,
  NgbModalRef,
} from '@ng-bootstrap/ng-bootstrap';
import { PopupDeleteComponent } from './delete-popup.component';
import { log } from 'console';
import { HttpResponse } from '@angular/common/http';
import { NgbPagination } from '@ng-bootstrap/ng-bootstrap';
import { pickBy, identity } from 'lodash';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-descargas',
  templateUrl: './descargas.component.html',
  styleUrls: ['./descargas.component.css'],
})
export class DescargasComponent implements OnInit {
  dataTable: any;
  dtOptions: any;
  tableData = [];
  @ViewChild('dataTable', { static: true }) table;
  @ViewChild('btnCloseNew', { static: true }) btnCloseNew: ElementRef;
  @ViewChild('btnCloseUpdate', { static: true }) btnCloseUpdate: ElementRef;
  @ViewChild('btnUpdateModal', { static: true }) btnUpdateModal: ElementRef;
  @ViewChild('userTable', { static: true }) userTable: ElementRef;
  userForm: FormGroup;
  userUpdateForm: FormGroup;
  userUpdateModel: any;
  userModel: any;
  roles = [];
  fileData: File = null;
  userPhoto: any = null;
  fileUploadProgress: string = null;
  uploadedFilePath: string = null;
  model: NgbDateStruct;
  date: { year: number; month: number };
  subscription: any;
  data: { title: 'Informes' };
  total$: Observable<number>;
  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;
  minDate: any;
  maxDate: any;
  prueba: any;

  DOWNLOADS: any = [];
  downloads: any;
  page = 1;
  pageSize = 10;
  collectionSize = this.DOWNLOADS.length;

  sortColumn: SortColumn;
  sortDirection: SortDirection;

  isLoading: boolean = true;
  @ViewChild('paginador') paginador: NgbPagination;

  filters: any;

  sortState: any;

  protected ngbModalRef: NgbModalRef;

  // tslint:disable-next-line: max-line-length
  constructor(
    private authService: AuthService,
    private appComponent: AppComponent,
    private navService: NavService,
    public sortService: SortService,
    public downloadsService: DownloadsService,
    private modalService: NgbModal,
    private toastrService: ToastrService,
    private translateService: TranslateService
  ) {
    Window['appuser'] = this;
  }

  ngOnInit() {
    // this.authService.isAuthenticated();
    this.refreshDownloads();
    this.selectedNavItem({
      parent: 'record.report',
      child: 'record.downloads',
      description: 'pageDescriptions.downloads',
    });
    // Min Date
    $('#minDate').flatpickr({
      dateFormat: 'd.m.Y',
      //minDate: "20.4.2023",
    });
    // Max Date
    $('#maxDate').flatpickr({
      dateFormat: 'd.m.Y',
      //maxDate: "25.4.2023"
    });
  }

  changeMinDate(e) {
    this.prueba = e.target.value;
    $('#maxDate')
      .flatpickr({
        dateFormat: 'd.m.Y',
        minDate: this.minDate,
      })
      .setDate(this.maxDate);
  }

  changeMaxDate() {
    $('#minDate')
      .flatpickr({
        dateFormat: 'd.m.Y',
        maxDate: this.maxDate,
      })
      .setDate(this.minDate);
  }

  refreshDownloads() {
    this.isLoading = true;
    this.downloadsService
      .getAllDownloads(this.page, this.filters)
      .subscribe((res) => {
        this.collectionSize = res.body['total'];
        this.downloads = res.body['results'];
        const uniqueUserIds = Array.from(
          new Set(this.downloads?.map((d) => d.idUsuario) || [])
        );
        uniqueUserIds.forEach((userId) => {
          this.authService.getAccount(userId).subscribe((resp) => {
            const userName = resp?.userlist?.name;
            this.downloads?.forEach((download) => {
              if (download.idUsuario === userId) {
                download.userName = userName;
              }
            });
          });
        });
        this.isLoading = false;
      });
  }

  onSort({ column, direction }: SortEvent) {
    // resetting other headers
    this.headers?.forEach((header) => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });
    this.sortColumn = column;
    this.sortDirection = direction;

    if (this.sortDirection !== '') {
      this.filters = {
        ...this.filters,
        sort: this.sortColumn,
        order: this.sortDirection,
      };
      this.sortState = {
        sort: this.sortColumn,
        order: this.sortDirection,
      };
    } else {
      delete this.filters.sort;
      delete this.filters.order;
      this.sortState = undefined;
    }
    this.refreshDownloads();
  }

  selectedNavItem(data: any) {
    this.navService.emitNavChangeEvent(data);
  }

  deleteDownload(id) {
    this.ngbModalRef = this.modalService.open(PopupDeleteComponent, {
      backdrop: 'static',
      centered: true,
      windowClass: 'modal-holder',
    });
    this.ngbModalRef.result.then(
      (result) => {
        this.downloadsService.deleteDownload(id).subscribe((res) => {
          if (
            this.paginador.pages[this.paginador.pages.length - 1] ===
              this.page &&
            (this.downloads?.length <= 1 || !this.downloads)
          ) {
            this.page = this.page - 1;
            this.refreshDownloads();
          } else {
            this.refreshDownloads();
          }
        });
      },
      (err) => {
        window.console.log('err');
      }
    );
  }

  downloadReport(id, date, query) {
    this.downloadsService.downloadReport(id).subscribe(
      (res: HttpResponse<Blob>) => {
        const nombreArchivo = `${query}${date}.xlsx`;
        const blob = new Blob([res.body], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = nombreArchivo;
        link.click();
        window.URL.revokeObjectURL(url);
      },
      (error) => {
        console.error(error);
        this.toastrService.info(
          this.translateService.instant('record.download.generatingDocument')
        );
      }
    );
  }

  invertirFormatoFecha(fechaOriginal: any): string {
    if (!fechaOriginal) {
      return '-';
    }
    const partes = fechaOriginal?.split(' - ');
    if (partes.length === 2) {
      const fechaInicio = partes[0];
      const fechaFin = partes[1];

      const [mesInicio, diaInicio, añoInicio] = fechaInicio
        .split('/')
        .map((part) => part.padStart(2, '0'));
      const [mesFin, diaFin, añoFin] = fechaFin
        .split('/')
        .map((part) => part.padStart(2, '0'));

      // Invertir el formato de mes y día
      const fechaInvertida = `${diaInicio}/${mesInicio}/${añoInicio} - ${diaFin}/${mesFin}/${añoFin}`;
      return fechaInvertida;
    } else {
      // Manejar un formato incorrecto si es necesario
      return fechaOriginal;
    }
  }

  translateStatus(status: any): string {
    if (!status) {
      return '-';
    }

    switch (status) {
      case 'Completed':
        return this.translateService.instant('record.table.status.completed');
      case 'Processing':
        return this.translateService.instant('record.table.status.processing');
      case 'Pending':
        return this.translateService.instant('record.table.status.pending');
      case 'Failed':
        return this.translateService.instant('record.table.status.failed');
      default:
        return status;
    }
  }
}
